export default __webpack_public_path__ + "locales/bg/SocialAuthWelcomeDialog.json?hash=6c6e034b0d0e3918eae08a97d8eb2ad2";